import React, { useState, useEffect } from 'react'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import { useSelector } from 'react-redux'
import CircularProgress from '@mui/material/CircularProgress'
import Box from '@mui/material/Box'
import Alert from '@mui/material/Alert'
import { useAppDispatch, RootState, AppDispatch } from '../../redux/store'
import { useParams } from 'react-router-dom'
import { SelectChangeEvent } from '@mui/material/Select'
import { NumberTextField } from '../../components/common/NumberInput'
import { Breadcrumbs, Grid, Link, Paper, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { CoutSupplementaire } from '../../types/coutSupplementaireTypes'
import {
  getCoutSupplementairebyId,
  updateCoutSupplementaire,
} from '../../redux/CoutSupplementaire/coutSupplementaireAction'
import UseAlert from '../../components/common/alert'
import { t } from 'i18next'

export default function CoutSupplementaireUpdate() {
  const [coutSupplementaire, setCoutSupplementaire] =
    useState<CoutSupplementaire>({
      CoutSupplementaireId: '',

      Montant: 0,
      ActionId: '',
    })

  const [alert, setAlert] = useState({
    open: false,
    message: '',
    severity: '' as 'info' | 'success' | 'error' | 'warning',
  })

  const handleCloseAlert = () => {
    setAlert({
      ...alert,
      open: false,
    })
  }
  const dispatch: AppDispatch = useAppDispatch()
  const coutSupplementairesList = useSelector(
    (state: RootState) => state.coutSupplementaire.coutSupplementaire
  )
  const loading = useSelector(
    (state: RootState) => state.coutSupplementaire.loading
  )
  const error = useSelector(
    (state: RootState) => state.coutSupplementaire.error
  )
  const { id } = useParams<{ id: string }>()
  const navigate = useNavigate()
  useEffect(() => {
    if (id) {
      dispatch(getCoutSupplementairebyId(id))
    }
  }, [dispatch, id])

  useEffect(() => {
    if (coutSupplementairesList !== null) {
      setCoutSupplementaire({
        _id: coutSupplementairesList._id,
        CoutSupplementaireId: coutSupplementairesList.CoutSupplementaireId,

        Montant: coutSupplementairesList.Montant,
        ActionId: coutSupplementairesList.ActionId,
      })
    }
  }, [coutSupplementairesList])

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target
    setCoutSupplementaire((prevCoutSupplementaire) => ({
      ...prevCoutSupplementaire,
      [name]: value,
    }))
  }

  const handleUpdateCoutSupplementaire = async () => {
    try {
      if (coutSupplementaire.Montant && coutSupplementaire._id) {
        await dispatch(
          updateCoutSupplementaire({
            updatedCoutSupplementaire: coutSupplementaire,
            _id: coutSupplementaire._id,
          })
        )
        console.log(coutSupplementaire)

        setAlert({
          open: true,
          message: t('alerts.coutSuppUpdate.success'),
          severity: 'success',
        })
      } else {
        setAlert({
          open: true,
          message: t('alerts.coutSuppUpdate.emptyFields'),
          severity: 'error',
        })
      }
    } catch (error: any) {
      console.error('Error updating cost:', error.message)

      setAlert({
        open: true,
        message: t('alerts.coutSuppUpdate.error'),
        severity: 'error',
      })
    }
  }

  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
        }}
      >
        <CircularProgress />
      </Box>
    )
  }

  if (error) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
        }}
      >
        <Alert severity="error">{error}</Alert>
      </Box>
    )
  }

  return (
    <div>
      <Grid marginTop={'16px'} marginBottom={'22px'}>
        <Grid item xs>
          <Breadcrumbs separator="/" aria-label="breadcrumb">
            <Link
              onClick={() => navigate(`/`)}
              color="primary"
              component="button"
            >
              Home
            </Link>
            <Link
              onClick={() =>
                navigate(`/actiond/${coutSupplementaire.ActionId}`)
              }
              color="primary"
              component="button"
            >
              Action
            </Link>
          </Breadcrumbs>
        </Grid>
      </Grid>
      <Paper className="paper-flex-column">
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '24px',
            width: '960px',
          }}
        >
          <Typography variant="h4" component="h4" color="">
            update CoutSupplementaire
          </Typography>
        </div>
        <UseAlert
          open={alert.open}
          message={alert.message}
          severity={alert.severity}
          onClose={handleCloseAlert}
        />
        <form style={{ width: '100%', marginTop: '20px' }}>
          <Stack direction="column" spacing={2}>
            <NumberTextField
              currency
              label={t('popups.addAdditionalCost.fields.Montant')}
              name="Montant"
              value={coutSupplementaire.Montant}
              onChange={(v) =>
                setCoutSupplementaire((prev) => ({ ...prev, Montant: v ?? 0 }))
              }
              fullWidth
              required
            />

            <Button
              variant="contained"
              color="primary"
              onClick={handleUpdateCoutSupplementaire}
            >
              Modifier
            </Button>
            <Button variant="outlined" color="primary">
              Anuuler
            </Button>
          </Stack>
        </form>
      </Paper>
    </div>
  )
}
